"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("./styles");

var _ContentRow = _interopRequireDefault(require("../ContentRow"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DetailRow = function DetailRow(_ref) {
  var columnSections = _ref.columnSections,
      columnQuantity = _ref.columnQuantity,
      startDatetime = _ref.startDatetime,
      columnRangeType = _ref.columnRangeType,
      detail = _ref.detail;
  return /*#__PURE__*/_react["default"].createElement(_styles.Wrapper, null, detail.map(function (_ref2) {
    var items = _ref2.items;
    return /*#__PURE__*/_react["default"].createElement(_styles.WrapperRowContent, null, /*#__PURE__*/_react["default"].createElement(_ContentRow["default"], {
      assemble: items,
      columnSections: columnSections,
      columnQuantity: columnQuantity,
      startDatetime: startDatetime,
      columnRangeType: columnRangeType
    }));
  }));
};

DetailRow.propTypes = {
  columnSections: _propTypes["default"].number,
  columnQuantity: _propTypes["default"].number,
  startDatetime: _propTypes["default"].instanceOf(Date),
  columnRangeType: _propTypes["default"].oneOf(['HOUR', 'DAY']),
  detail: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      available: _propTypes["default"].bool,
      begin: _propTypes["default"].instanceOf(Date),
      end: _propTypes["default"].instanceOf(Date),
      data: _propTypes["default"].any,
      status: _propTypes["default"].bool,
      icon: _propTypes["default"].any
    }))
  }))
};
DetailRow.defaultProps = {
  columnSections: 8,
  columnQuantity: 7,
  startDatetime: new Date(),
  columnRangeType: 'DAY',
  detail: []
};
var _default = DetailRow;
exports["default"] = _default;